module.exports = __webpack_public_path__ + "static/media/mp3-icon.7e95ca30.svg";